<div class="bddc-calendar">

  @if (!hasData) {
    <div class="app-loader">
      <div class="u-flex-center">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
    </div>
  }

  <div class="bddc-calendar_container">
    <full-calendar #calendar [options]="calendarOptions">
    </full-calendar>
  </div>

  @if (dateTitle) {
    <div class="bddc-calendar_panel">
      <div class="bddc-calendar_panel-inner">
        <div class="bddc-calendar_panel-heading">
          <div class="bddc-calendar_add-service-mobile">
            <div class="calendar-divider"></div>
            @if (activeUser) {
              <button mat-raised-button color="primary" (click)="addService()" [disabled]="!addServiceButtonEnabled">
                <mat-icon>add</mat-icon>
                Add service
              </button>
            }
            @if (!activeUser) {
              <button mat-raised-button color="primary" (click)="addService()" [disabled]="!activeUser">
                <mat-icon>add</mat-icon>
                Add service
              </button>
            }
          </div>
          <div class="heading-wrapper">
            <div class="text-container">
              <h2 class="mat-headline-2">
                @if (displayOnlyForToday) {
                  <span class="u-mobile-only">Today </span>
                  }{{ dateTitle }}
                </h2>
                @if (selectedDayTheme) {
                  <p class="">Theme: {{ selectedDayTheme.title }}</p>
                }
              </div>
              @if (selectedDayTheme) {
                <img [src]="selectedDayTheme.icon" alt="Theme Icon" class="theme-icon" />
              }
            </div>
            <div class="calendar-divider"></div>
          </div>
          <div class="bddc-calendar_panel-content">
            @if (selectedDateServices.length === 0) {
              <p class="mat-body-medium u-text-center">
                Sorry, no services for this day
              </p>
            }
            @if (selectedDateServices) {
              @for (service of selectedDateServices; track service) {
                <div class="bddc-calendar-panel-item">
              <div class="bddc-calendar-panel-item_status {{
                  service.status ? service.status : 'yellow'
                }}"></div>
                  <p class="mat-body-medium bddc-calendar-panel-item_title u-text-no-margin">
                    @if (service.serviceCategory) {
                      {{ service.serviceCategory }}:
                    }
                    <b class="margin-right_5">{{ service.serviceType }}</b>
                    @if (service.dogName) {
                      <span>
                        ({{ service.dogName }}){{ service['notAttending'] ? ' - ****' : ''}}{{service.swapDay &&
                        !service.oldSwap.swapDay && !dateHasPendingSwap ? ' - *****' :
                        ''}}<br>{{ service.oldSwap.swapDay ? ' Swapped to: ' + service.oldSwap.swappedTo : '' }}
                      </span>
                      @if (service.pickupOwnersDrop == false && service.dropoffOwnersDrop == false) {
                        <div
                          class="route-icons">
                          <mat-icon matTooltip="Doggy Bus">
                            directions_bus_filled_rounded
                          </mat-icon>
                        </div>
                      }
                      @if (service.pickupOwnersDrop == true && service.dropoffOwnersDrop == true) {
                        <div
                          class="route-icons">
                          <mat-icon matTooltip="Parent Drop">
                            person_rounded
                          </mat-icon>
                        </div>
                      }
                      @if (service.pickupOwnersDrop == true && service.dropoffOwnersDrop == false) {
                        <div
                          class="route-icons">
                          <mat-icon matTooltip="Parent Drop">
                            person_rounded
                          </mat-icon>
                          /
                          <mat-icon matTooltip="Doggy Bus">
                            directions_bus_filled_rounded
                          </mat-icon>
                        </div>
                      }
                      <span>
                        @if (service.pickupOwnersDrop == false && service.dropoffOwnersDrop == true) {
                          <div
                            class="route-icons">
                            <mat-icon matTooltip="Doggy Bus">
                              directions_bus_filled_rounded
                            </mat-icon>
                            /
                            <mat-icon matTooltip="Parent Drop">
                              person_rounded
                            </mat-icon>
                          </div>
                        }
                      </span>
                    }
                    @if (service.pendingCancellation) {
                      *
                    }
                    @if (service.isRequest) {
                      **
                    }
                    @if (service.pendingSwap) {
                      ***
                    }
                  </p>
                </div>
                <div class="bddc-calendar-panel-item_actions">
                  @if (activeUser) {
                    <div class="bddc-calendar-panel-item_action remove">
                  <button mat-button aria-label="Remove service" (click)="remove(service)" [disabled]="
                    !addServiceButtonEnabled || service.pendingCancellation || service.oldSwap.swapDay || (service.pendingSwap && service.id)
                    || service['notAttending']">
                        Cancel
                      </button>
                    </div>
                  }
                  @if (activeUser) {
                    @if (
                      service.canSwap &&
                      !service.pendingSwap &&
                      !service.fiveDaysAWeek &&
                      !service.pendingCancellation &&
                      !service.oldSwap.swapDay
                      ) {
                      <div class="bddc-calendar-panel-item_action"
                        [ngClass]="{'swap' : !showGreySwapButton , 'swap-grey': showGreySwapButton}">
                        <button mat-button aria-label="Swap service" (click)="swapService(service)">
                          Swap
                        </button>
                      </div>
                    }
                  }
                </div>
                <div class="calendar-divider"></div>
              <!-- </ng-container> -->
            }
          }
          @if (dateHasPendingCancellation) {
            <p class="mat-body-medium cancellation-legend">
              * Pending cancellation
            </p>
          }
          @if (dateHasPendingRequest) {
            <p class="mat-body-medium cancellation-legend">
              ** Pending request
            </p>
          }
          @if (dateHasPendingSwap) {
            <p class="mat-body-medium cancellation-legend">
              *** Pending swap day
            </p>
          }
          @if (notAttendingLegendDisplay) {
            <p class="mat-body-medium cancellation-legend">
              **** Not attending
            </p>
          }
          @if (notAttendingRefundedLegendDisplay) {
            <p class="mat-body-medium cancellation-legend">
              **** Not attending (Absent)
            </p>
          }
          @if (dateHasSwapDay && !dateHasPendingSwap) {
            <p class="mat-body-medium cancellation-legend">
              ***** Swapped Day
            </p>
          }
        </div>
        <div class="bddc-calendar_panel-footer">
          <div class="calendar-divider"></div>
          @if (activeUser) {
            <button id="add-service-button" mat-raised-button color="primary" (click)="addService()"
              [disabled]="!addServiceButtonEnabled">
              <mat-icon>add</mat-icon>
              Add service
            </button>
          }
          @if (!activeUser) {
            <button mat-raised-button color="primary" (click)="addService()" [disabled]="!activeUser">
              <mat-icon>add</mat-icon>
              Add service
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>